import { atom } from 'jotai';

/** 이미지 업로드가 끝나기 전인 보기 id. 빈 보기 정리는 이 보기를 비었다고 보지 않는다. 업로드 하나당 한 번씩 담겨, 같은 보기에 겹친 업로드가 모두 끝나야 빠진다. */
export const pendingImageUploadIdsAtom = atom<readonly string[]>([]);
